import { NavLink } from "react-router-dom";
import "../style/Header.css";

const Header: React.FC = () => {
  return (
    <div className="top-0 border-b-2 border-gray flex flex-row justify-around items-center p-5">
      <NavLink to="/"><h1 className="text-xl">Jun Wei Huang</h1></NavLink>
      {/* <NavLink to="/"><h1 className="hidden text-xl">Home</h1></NavLink> */}
    </div>
  );
};
export default Header;
